import React from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import "./App.css";

function App() {
  return (
    <div className="app-background d-flex justify-content-center align-items-center">
      <div className="panel bg-dark  text-white p-5 bg-opacity-50 rounded shadow">
        <h1 className="mb-4 text-center">Moje Strony</h1>
        <div className="d-flex flex-column gap-3">
          <a className="btn btn-secondary rounded" href="https://www.sewnow.online/" target="_blank" rel="noopener noreferrer">Aplikacja webowa do ogłaszania lotów komercyjnych</a>
          <a className="btn btn-secondary rounded" href="https://www.xn--lilianakudowicz-qkd.art/" target="_blank" rel="noopener noreferrer">Strona artysty</a>
          <a className="btn btn-secondary rounded" href="" target="_blank" rel="noopener noreferrer">Strona 3</a>
        </div>
      </div>
    </div>
  );
}

export default App;
